import ManageCultureTable from './ManageCultureTable'
import ManageCultureDetails from './ManageCultureDetails'

const ManageCulture = {
  Table: ManageCultureTable,
  Details: ManageCultureDetails,
}

export default ManageCulture
